module.exports = __webpack_public_path__ + "static/media/noticePeriod.c2fb2145.svg";